import Vue from 'vue'
import Router from 'vue-router'
import getUrlParams from '@/utils/getUrlParams'

Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/maintenance',
    name: 'maintenance',
    component: () => import(/* webpackChunkName: "maintenance" */ './views/Maintenance/Maintenance.vue'),
    meta: {
      requireAuth: false,
    },
  },
  {
    path: '/signIn',
    name: 'signIn',
    component: () => import(/* webpackChunkName: "signIn" */ './views/SignIn/SignIn.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/dailyQuestion',
    name: 'dailyQuestion',
    component: () => import(/* webpackChunkName: "dailyQuestion" */ './views/DailyQuestion/DailyQuestion.vue'),
    meta: {
      requireAuth: true,
    },
  },
  ],
})

function wxAuth(cb = () => {}) {
  loginManager.on('login', (userInfo) => {
    cb(userInfo)
  })

  loginManager.check()
}

router.beforeEach((to, from, next) => {
  const { requireAuth } = to.meta
  const isDevMod = getUrlParams('debug') === 'true'
  const maintenance = process.env.VUE_APP_MAINTENANCE === 'true'

  if (to.path !== '/maintenance' && maintenance && !isDevMod) {
    next('/maintenance')
  } else if (requireAuth) {
    loginManager.isLogin((logined) => {
      logined === true ? next() : wxAuth(next)
    })
  } else {
    next()
  }
})

export default router
